import React from 'react';
import PropTypes from 'prop-types';
import {
  content as ContentPropType,
  coverSpreadTease as TeasePropTypes,
  responsiveFlavors as ResponsiveFlavorsPropTypes,
} from 'lib/CustomPropTypes';
import { getVerticalName } from 'lib/verticalType';
import classNames from 'classnames';

import Link from 'components/Link';
import MediaLabel from 'components/MediaLabel';
import TeasePicture from 'components/TeasePicture';
import Unibrow from 'components/Unibrow';


function CoverSpreadTease({
  content,
  showInlineIcon,
  showUnibrow,
  layout = {},
  responsiveFlavors: fallbackSizes,
  headlineSizes: fallbackHeadlineSizes,
  index,
}) {
  const {
    computedValues: { headline, unibrow, url } = {}, id, item = {}, type,
  } = content;
  const {
    image: { display = '', sizes } = {},
    headlineSizes,
    headlineTextPositioning = '',
    mediaLabel: { eyebrowDisplay = '', iconBlockDisplay = '', iconInlineDisplay = '' } = {},
  } = layout[`tease${index}`] || {};
  const block = 'cover-spread-tease';

  const contentTypesWithIcons = ['slideshow', 'video'];
  const isContentTypeWithIcons = (contentType) => (
    contentType && contentTypesWithIcons.includes(contentType)
  );

  const verticalName = getVerticalName({ item });

  return (
    <div
      className={classNames(block, { [`${block}--${index}`]: index >= 0 })}
      data-contentid={id}
    >
      <div className={classNames(`${block}__image`, display)} data-test={`${block}__image`}>
        <Link href={url} className={`${block}__image-link`}>
          <TeasePicture
            computedValues={content.computedValues}
            lazyload
            retina
            responsiveFlavors={sizes || fallbackSizes}
            type={type}
            className={`${block}__picture`}
            placeholder={false}
          />
          <MediaLabel
            content={content}
            eyebrowClasses={eyebrowDisplay}
            iconBlockClasses={iconBlockDisplay}
          />
        </Link>
      </div>
      <div
        className={`${block}__text-wrapper`}
        data-test={`${block}__text-wrapper`}
      >
        {showUnibrow && unibrow.text && (
          <Unibrow
            unibrow={unibrow}
            className={classNames(
              `${block}__unibrow`,
              {
                [`${block}__unibrow--opinion`]: verticalName === 'think',
              },
            )}
          />
        )}
        <h3 className={classNames(`${block}__headline`, headlineSizes || fallbackHeadlineSizes)} data-test={`${block}__headline`}>
          <Link href={url}>
            {showInlineIcon
              && (
                <MediaLabel
                  content={content}
                  showInlineIcon={showInlineIcon}
                  iconInlineClasses={iconInlineDisplay}
                />
              )}
            <span
              className={classNames(
                {
                  [`${headlineTextPositioning}`]: isContentTypeWithIcons(type),
                },
              )}
              data-test={`${block}__headline__text`}
            >
              {headline || item.headline.primary}
            </span>
          </Link>
        </h3>
      </div>
    </div>
  );
}

CoverSpreadTease.propTypes = {
  content: ContentPropType.isRequired,
  showInlineIcon: PropTypes.bool,
  showUnibrow: PropTypes.bool,
  layout: TeasePropTypes,
  responsiveFlavors: ResponsiveFlavorsPropTypes,
  headlineSizes: PropTypes.string,
  index: PropTypes.number,
};

CoverSpreadTease.defaultProps = {
  responsiveFlavors: {},
  showInlineIcon: false,
  showUnibrow: false,
  layout: {},
  headlineSizes: '',
  index: null,
};

export default CoverSpreadTease;
